import StoryModule from '../components/StoryModule';

const TurningPoint = () => <StoryModule slug="turning-point" />;

export default TurningPoint;
